import React, { useState, useEffect, useRef } from "react";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Dialog from "@material-ui/core/Dialog";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { withStyles } from "@material-ui/core/styles";
import { Grid, Chip } from "@material-ui/core";
import {MultiSelect} from "react-multi-select-component";

import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import AccountCircle from "@material-ui/icons/AccountCircle";
import MenuItem from "@material-ui/core/MenuItem";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import { TextField, Button } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import { Autocomplete } from "@material-ui/lab";
import AddIcon from "@material-ui/icons/Add";
import { RoleAction } from "../../actions/role";
import { SiteAction } from "../../actions/site";
import { useHistory } from "react-router-dom";
import ClearIcon from "@material-ui/icons/Clear";
import readXlsxFile from "read-excel-file";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import Container from "@material-ui/core/Container";
import { VehicleAction } from "../../actions/vehicle";
import CancelIcon from "@material-ui/icons/Cancel";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import chargeSample from "../../DieselRequestVehicleAdd.xlsx";
import { DieselRequestAction } from "../../actions/DieselRequest";
import { userService } from "../../services";

// import { configbaseUrl } from "../../config/config";
import config from "../../config/config";
import ExcelExportModal from "./ExcelExportModal";
const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#ebebeb",
    color: theme.palette.common.black,
    border: "1px solid #bfbfbf",
    padding: "10px",
  },
  body: {
    fontSize: 14,
    border: "1px solid #bfbfbf",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    background: "#fff",
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: "#F8FCFF",
    },
  },
}))(TableRow);

const VehicleAddExcel = ({
  excelImport,
  closeExcelImportModal,
  setLoading,
  openExcelImport,
  setOpenExcelImport,
  loading,
  handlemodal,
  getRequestList,
}) => {
  const [fullWidth, setFullWidth] = React.useState(true);
  const [maxWidth, setMaxWidth] = React.useState("md");
  const [multiVehicles, setMultiVehicles] = React.useState([]);
  const [siteId, setSiteId] = React.useState("");
  const [count, setCount] = React.useState(0);
  const [show, setShow] = React.useState(false);
  const [vendorid, setVendorId] = useState([]);
  const [fileName, setFileName] = useState("");
  console.log(fileName, "fileName");
  const fileRef = useRef(null);
  const [showExcelModal, setShowExcelModal] = useState(false);
  const [siteLocationsArray, setSiteLocationsArray] = useState([]);
  const [openExelModal, setOpenExelModal] = useState(false);
  const [excelexportStataus, setExcelexportStataus] = useState([]);
  console.log(excelexportStataus, "excelexportStataus");
  const history = useHistory();

  const styles = (theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

  const handleCancel = () => {
    handlemodal();
  };

  const handleExcelOpen = () => {
    setOpenExelModal(true);
  };
  const handleExcelClose = () => {
    setOpenExelModal(false);
  };

  const handleUpdate = () => {
  // document.getElementById("inputFile").click();
  //debugger
  console.log(multiVehicles)
  // alert("uh")

    // addVehicle(multiVehicles[0], 0);
    let data = {
      fuelFillRequestDTOList: multiVehicles,
    };
    let path = `${JSON.parse(localStorage.getItem("config")).baseUrl}${
      config.apiName.DieselRequestCreate
    }`;
    console.log(data, path);
    userService
      .post(path, data)
      .then((res) => {
        console.log(res);
        setExcelexportStataus(res.data);
        getRequestList();
      })
      .catch((er) => {
        console.log(er);
      });
    handlemodal();
    setOpenExelModal(true);

    document.getElementById("dieselRequest").value = "";
  };

  const ExcelExportSubmitdata = () => {};

  var vendor = [];
  const addVehicle = (value, index) => {
    console.log(value);

   
    ////debugger;

    setLoading(true);
    let data = new FormData();
    data.append("S,NO");
    data.append("number", value.number);
    data.append("requestedFuelQuantity", value.requestedFuelQuantity);
    data.append("Remarks", value.Remarks);
  };

  const checkCount = () => {
    const check = multiVehicles.filter((val) => val.success === "true");

    setCount(check.length);
  };

  let vehicleArray = [];
  const onFIleChange =(event) => {
    //debugger
    // alert("yugedfuy")
    console.log(fileRef.current.value)
    const input = document.getElementById("dieselRequest");
    // readXlsxFile(input.files[0]).then(rows=>{
    //   console.log(rows)
    // }).catch(err=>{
    //   console.log(err)
    // })
    
    if (event.target.name === "dieselRequest") {
      if (fileRef.current.files[0]) {
        console.log(fileRef.current.files[0]);
        setFileName(fileRef.current.files[0].name);
      } else {
        setFileName("");
      }
    }

    readXlsxFile(input.files[0]).then((rows) => {
      console.log(rows);

      for (var i = 1; i < rows.length; i++) {
        console.log(rows[i][2]);
        let vehicleObj = {
          companyId: JSON.parse(localStorage.getItem("data")).companyId,
          userId: JSON.parse(localStorage.getItem("data")).id,
          vehicleNumber: "",
          requestedFuelQuantity: "",
          requestRemarks: "",
        };

        if (
          rows[i][0] &&
          rows[i][1] &&
          rows[i][2]
         
          
        ) {
          vehicleObj.vehicleNumber = rows[i][0];
          vehicleObj.requestedFuelQuantity = rows[i][1];
          vehicleObj.requestRemarks = rows[i][2];
          console.log(vehicleObj);
          vehicleArray.push(vehicleObj);
          console.log(vehicleArray);
        }
      }
      setMultiVehicles(vehicleArray);
    });
  };

  const closePop = () => {
    closeExcelImportModal();
    setShow(false);
    setMultiVehicles([]);
  };

  const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={handleCancel}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  });

  return (
    <div>
      <div>
        <ExcelExportModal
          openExelModal={openExelModal}
          handleExcelClose={handleExcelClose}
          excelexportStataus={excelexportStataus}
        />
        <Dialog
          aria-labelledby="customized-dialog-title"
          open={openExcelImport}
          onClose={closeExcelImportModal}
          fullWidth={fullWidth}
          maxWidth={maxWidth}
        >
          <DialogTitle
            id="customized-dialog-title"
            onClose={closeExcelImportModal}
          >
            <span
              className="font14"
              style={{ fontWeight: "bold", marginLeft: "10px" }}
            >
              Import Vehicle By Excel
            </span>
          </DialogTitle>
          <DialogContent dividers>
            <div>
              {" "}
              <a className="float-right" href={chargeSample} download>
                Download Vehicle Excel Template
              </a>
            </div>

            <Grid
              container
              spacing={3}
              style={{ marginLeft: "-23px", marginBottom: "2px" }}
            >
                 <Grid item xs={4}>
                {!show ? (
                  <>
                    <Typography
                      className="font14 greyfirstheading"
                      gutterBottom
                      variant="subtitle1"
                    >
                      Import Excel
                    </Typography>
                    <Typography variant="body2" gutterBottom className="py-2">
                      <input
                        type="file"
                        id="dieselRequest"
                        ref={fileRef}
                        name="dieselRequest"
                        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,xlsx"
                        onChange={onFIleChange}
                      />
                    </Typography>
                  </>
                ) : (
                  ""
                )}
              </Grid>

              <Grid item xs={4}>
                <Typography
                  className="font14 greyfirstheading"
                  gutterBottom
                  variant="subtitle1"
                >
                  {show ? (
                    <div className="mt-4">
                      Request Upload SuccessFully {count}/{multiVehicles.length}{" "}
                    </div>
                  ) : (
                    ""
                  )}
                </Typography>
              </Grid>
            </Grid>

            <TableContainer>
              <Table aria-label="customized table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell>#</StyledTableCell>
                    <StyledTableCell>Vehicle Number</StyledTableCell>
                    <StyledTableCell>Requested Fuel Quantity</StyledTableCell>
                    {/* <StyledTableCell>Status</StyledTableCell> */}
                    <StyledTableCell>Remarks</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {multiVehicles &&
                    multiVehicles.length > 0 &&
                    multiVehicles.map((vehicle, index) => (
                      <StyledTableRow key={vehicle.id}>
                        <StyledTableCell component="th" scope="row">
                          {index + 1}
                        </StyledTableCell>

                        <StyledTableCell
                          style={{ color: "#154360", cursor: "pointer" }}
                        >
                          {vehicle.vehicleNumber}
                        </StyledTableCell>
                        <StyledTableCell>
                          {vehicle.requestedFuelQuantity}
                        </StyledTableCell>
                        <StyledTableCell>
                          {vehicle.requestRemarks}
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </DialogContent>
          <DialogActions>
            {!show ? (
              <>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={handleCancel}
                >
                  Cancel
                </Button>
                <Button
                  style={{ marginLeft: "1rem" }}
                  variant="contained"
                  onClick={handleUpdate}
                >
                  Submit
                </Button>
              </>
            ) : (
              ""
            )}
          </DialogActions>
        </Dialog>
      </div>
    </div>
  );
};

export default VehicleAddExcel;
